module.exports = __webpack_public_path__ + "img/yd-sh-img.5f874163.png";